import { create } from 'zustand';

import type { ProjectOptionModel, ProjectOptionProps } from '@/domain/models/project.js';
import { ProjectOptionModel as ProjectOptionModelClass } from '@/domain/models/project.js';

interface ProjectState {
    projects: ProjectOptionModel[];
    selectedProject: ProjectOptionModel | null;
    loading: boolean;
    setProjects: (projects: ProjectOptionModel[]) => void;
    setSelectedProject: (project: ProjectOptionModel | null) => void;
    setLoading: (loading: boolean) => void;
    clear: () => void;
}

function loadSaved(): ProjectOptionModel | null {
    try {
        const saved = localStorage.getItem('selectedProject');
        if (saved) {
            const raw = JSON.parse(saved) as ProjectOptionProps;
            return ProjectOptionModelClass.with(raw);
        }
    } catch {
        // ignore
    }
    return null;
}

export const useProjectStore = create<ProjectState>((set) => ({
    projects: [],
    selectedProject: loadSaved(),
    loading: false,
    setProjects: (projects) => {
        set((s) => {
            if (s.selectedProject && !projects.find((p) => p.id === s.selectedProject!.id)) {
                localStorage.removeItem('selectedProject');
                return { projects, selectedProject: null };
            }
            return { projects };
        });
    },
    setSelectedProject: (project) => {
        if (project) {
            localStorage.setItem('selectedProject', JSON.stringify(project.toObject()));
        } else {
            localStorage.removeItem('selectedProject');
        }
        set({ selectedProject: project });
    },
    setLoading: (loading) => set({ loading }),
    clear: () => {
        localStorage.removeItem('selectedProject');
        set({ projects: [], selectedProject: null, loading: false });
    }
}));
